/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Segment, Grid, Divider, Header, List,
  Button, Icon, Dimmer, Loader, Modal
} from "semantic-ui-react";
import { connect } from "react-redux";
import { pdf } from "@react-pdf/renderer";
import ProblemCard from "./ProblemCard";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import TsExpertReport from "./TsExpertReport";
import Utils from "../utilities/Utils";
import { solveProblemAction } from "../../actions/changeActiveItemActions";

const UtilsInstance = new Utils();

export class TSExpert extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      nowMillis: Date.now(),
      lastUpdate: new Date(),
      networkTag: "",
      uptime: "",
      startTime: "",
      problems: [],
      groupedProblems: {
        "diagnostic": [],
        "fault": [],
        "duplicatedIp": [],
        "duplicatedName": [],
        "avgPingExceededLimit": [],
        "deltaErr": [],
        "wrongMAUType": [],
        "excessKbps": [],
        "inactivePort": [],
        "firmwareIncoherence": [],
        "moduleIncoherence": [],
        "duplexMismatch": [],
        "lineDelayExceededLimit": [],
        "intermittentFailure": [],
        "lostIp": []
      },
      currentProblemType: "",
      currentProblemList: [],
      // The report
      isGenerateReportDimmerActive: false,
      // Modal
      showModal: false
    };
  }

  retrieveData = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "tsExpert", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      // Get the start time
      fetch(Constants.REQUEST_IP_ADDRESS + "startTime", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.startTime)
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    this.setState({
      problems: resolvedPromisses[0],
      startTime: resolvedPromisses[1],
    }, () => {
      this.checkProblemsListSize();
      this.groupProblemsByType();
    });
  }

  retrieveTagAndUptimeData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "homePage", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        networkTag: data.networkTag,
        uptime: this.formatToRelativeTime(data.uptime)
      }));
  }

  getDaysInMonth = (month, year) => {
    if (typeof year == "undefined") year = 1999; // any non-leap-year works as default     
    let currmon = new Date(year, month),
      nextmon = new Date(year, month + 1);
    return Math.floor((nextmon.getTime() - currmon.getTime()) / (24 * 3600 * 1000));
  }

  getDateTimeSince = (target) => { // target should be a Date object
    let now = new Date(), yd, md, dd, hd, nd, sd, out = [];

    yd = now.getFullYear() - target.getFullYear();
    md = now.getMonth() - target.getMonth();
    dd = now.getDate() - target.getDate();
    hd = now.getHours() - target.getHours();
    nd = now.getMinutes() - target.getMinutes();
    sd = now.getSeconds() - target.getSeconds();

    if (md < 0) { yd--; md += 12; }
    if (dd < 0) {
      md--;
      dd += this.getDaysInMonth(now.getMonth() - 1, now.getFullYear());
    }
    if (hd < 0) { dd--; hd += 24; }
    if (nd < 0) { hd--; nd += 60; }
    if (sd < 0) { nd--; sd += 60; }

    if (yd > 0) out.push(yd + Strings.YEAR + (yd === 1 ? "" : "s"));
    if (md > 0) {
      if (md === 1) {
        out.push(md + Strings.MONTH);
      }
      else {
        out.push(md + Strings.MONTHS);
      }
    }
    if (dd > 0) out.push(dd + Strings.DAY + (dd === 1 ? "" : "s"));
    if (hd > 0) out.push(hd + Strings.HOUR + (hd === 1 ? "" : "s"));
    if (nd > 0) out.push(nd + Strings.MINUTE + (nd === 1 ? "" : "s"));
    //if (sd > 0) out.push(sd + " segundo" + (sd === 1 ? "" : "s"));
    return out.join(" ");
  }

  formatToRelativeTime = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      const uptimeInMillis = uptimeInSeconds * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return this.getDateTimeSince(new Date(dateWhenWasTurnedOn));
    }
  }

  checkProblemsListSize = () => {
    if (this.state.problems.length > 0) {
      document.getElementById("problems-list").style.display = "block";
      document.getElementById("no-problem-detected-header").style.display = "none";
    }
    else {
      document.getElementById("problems-list").style.display = "none";
      document.getElementById("no-problem-detected-header").style.display = "block";
    }
  }

  groupProblemsByType = () => {
    let newGroupedProblems = {
      "diagnostic": [],
      "fault": [],
      "duplicatedIp": [],
      "duplicatedName": [],
      "avgPingExceededLimit": [],
      "deltaErr": [],
      "wrongMAUType": [],
      "excessKbps": [],
      "inactivePort": [],
      "firmwareIncoherence": [],
      "moduleIncoherence": [],
      "duplexMismatch": [],
      "lineDelayExceededLimit": [],
      "intermittentFailure": [],
      "lostIp": [],
    };

    for (let i = 0; i < this.state.problems.length; i++) {
      if (this.state.problems[i].type === Constants.DIAGNOSTIC_ERROR_TYPE) {
        newGroupedProblems.diagnostic.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.FAULT_ERROR_TYPE) {
        newGroupedProblems.fault.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.DUPLICATE_IP_ERROR_TYPE) {
        newGroupedProblems.duplicatedIp.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.DUPLICATE_NAME_ERROR_TYPE) {
        newGroupedProblems.duplicatedName.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.PING_ERROR_TYPE) {
        newGroupedProblems.avgPingExceededLimit.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.DELTA_ERROR_TYPE) {
        newGroupedProblems.deltaErr.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE) {
        newGroupedProblems.wrongMAUType.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.TRAFFIC_EXCESS_ERROR_TYPE) {
        newGroupedProblems.excessKbps.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.INACTIVE_PORT_ERROR_TYPE) {
        newGroupedProblems.inactivePort.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.HW_FW_ERROR_TYPE) {
        newGroupedProblems.firmwareIncoherence.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.MODULE_INCOHERENCE_ERROR_TYPE) {
        newGroupedProblems.moduleIncoherence.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.DUPLEX_MISMATCH_ERROR_TYPE) {
        newGroupedProblems.duplexMismatch.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.DELAY_ERROR_TYPE) {
        newGroupedProblems.lineDelayExceededLimit.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.INTERMITENT_FAILURE_ERROR_TYPE) {
        newGroupedProblems.intermittentFailure.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.LOST_IP_ERROR_TYPE) {
        newGroupedProblems.lostIp.push(this.state.problems[i]);
      }
    }

    this.setState({ groupedProblems: newGroupedProblems });
  }

  // ------ Events List ------
  getListItem = (problemType, groupedProblemList) => {
    if (groupedProblemList.length > 0) {
      return (
        <List.Item className="ts-expert-event-item">
          <div className="ts-expert-event-count">{groupedProblemList.length}</div>
          <div className="ts-expert-event-content">
            {this.getListContent(problemType)}
          </div>
          <Button
            className="ts-expert-event-action"
            size="tiny"
            circular
            color="teal"
            icon="chevron right"
            onClick={this.handleDetailsButtonClick(problemType, groupedProblemList)} />
        </List.Item>
      );
    }
    else {
      return "";
    }
  }

  handleDetailsButtonClick = (problemType, groupedProblemList) => () => {
    this.setState({
      currentProblemType: problemType,
      currentProblemList: groupedProblemList
    }, () => {
      document.getElementById("no-task-selected-header").style.display = "none";
      document.getElementById("task-details").style.display = "block";
    });
  }

  getListContent = (problemType) => {
    if (problemType === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.DIAGNOSTIC_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.FAULT_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.FAULTS_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.DUPLICATE_IP_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.DUPLICATE_IP_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.DUPLICATE_NAME_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.DUPLICATE_NAME_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.PING_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.GROUP_PING_LIMIT_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.DELTA_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.DELTA_ERROR_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.NOT_IN_FULL_DUPLEX_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.TRAFFIC_EXCESS_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.TRAFFIC_EXCESS_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.INACTIVE_PORT_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.INACTIVE_PORT_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.HW_FW_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.HW_FW_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.MODULE_INCOHERENCE_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.MODULE_INCOHERENCE_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.DUPLEX_MISMATCH_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.DUPLEX_MISMATCH_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.DELAY_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.DELAY_EXCEEDED_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.INTERMITENT_FAILURE_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.INTERMITTENT_FAILURES_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.LOST_IP_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.LOST_IP_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.LOST_IP_DESCR}
          </List.Description>
        </List.Content>
      );
    }
  }

  // ------ Actions ------
  getActions = () => {
    if (this.state.currentProblemType === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.DIAGNOSTIC_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>{Strings.DIAGNOSTIC_SUGGESTION_2}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.FAULT_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.FAULT_SUGGESTION_1}</Header>
          <ul>
            <li>{Strings.FAULT_SUGGESTION_2}</li>
            <li>{Strings.FAULT_SUGGESTION_3}</li>
            <li>{Strings.FAULT_SUGGESTION_4}</li>
            <li>{Strings.FAULT_SUGGESTION_5}</li>
            <li>{Strings.FAULT_SUGGESTION_6}</li>
          </ul>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.DUPLICATE_IP_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.DUPLICATE_IP_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>{Strings.DUPLICATE_IP_SUGGESTION_2}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.DUPLICATE_NAME_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.DUPLICATE_NAME_SUGGESTION_1}</Header>
          <p>{Strings.DUPLICATE_NAME_SUGGESTION_2}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.PING_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.PING_LIMIT_SUGGESTION_1}</Header>
          <Header as="h3">{Strings.PING_LIMIT_SUGGESTION_2}</Header>

          <ul>
            <li>{Strings.PING_LIMIT_SUGGESTION_4}</li>
          </ul>

          <Header as="h3">{Strings.PING_LIMIT_SUGGESTION_5}</Header>
          <ul>
            <li>{Strings.PING_LIMIT_SUGGESTION_6}</li>
            <li>{Strings.PING_LIMIT_SUGGESTION_7}</li>
          </ul>

          <Header as="h3">{Strings.PING_LIMIT_SUGGESTION_8}</Header>
          <ul>
            <li>{Strings.PING_LIMIT_SUGGESTION_9}</li>
          </ul>

        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.DELTA_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.DELTA_ERRORS_SUGGESTION_1}</Header>

          <Header as="h4" style={headerStyle}>{Strings.DELTA_ERRORS_SUGGESTION_2}</Header>
          <ul>
            <li>{Strings.DELTA_ERRORS_SUGGESTION_3}</li>
            <li>{Strings.DELTA_ERRORS_SUGGESTION_4}</li>
            <li>{Strings.DELTA_ERRORS_SUGGESTION_5}</li>
            <li>{Strings.DELTA_ERRORS_SUGGESTION_6}</li>
          </ul>

          <Header as="h4" style={headerStyle}>{Strings.DELTA_ERRORS_SUGGESTION_7}</Header>
          <ul>
            <li>{Strings.DELTA_ERRORS_SUGGESTION_8}</li>
            <li>{Strings.DELTA_ERRORS_SUGGESTION_9}</li>
            <li>{Strings.DELTA_ERRORS_SUGGESTION_10}</li>
          </ul>

        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.NOT_IN_FULL_DUPLEX_SUGGESTION_1}</Header>
          <ul>
            <li>{Strings.NOT_IN_FULL_DUPLEX_SUGGESTION_2}</li>
            <li>{Strings.NOT_IN_FULL_DUPLEX_SUGGESTION_3}</li>
          </ul>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.TRAFFIC_EXCESS_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.TRAFFIC_EXCESS_SUGGESTION_1}</Header>
          <p>{Strings.TRAFFIC_EXCESS_SUGGESTION_2}</p>
          <ul>
            <li>{Strings.TRAFFIC_EXCESS_SUGGESTION_3}</li>
            <li>{Strings.TRAFFIC_EXCESS_SUGGESTION_4}</li>
            <li>{Strings.TRAFFIC_EXCESS_SUGGESTION_5}</li>
            <li>{Strings.TRAFFIC_EXCESS_SUGGESTION_6}</li>
          </ul>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.INACTIVE_PORT_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.INACTIVE_PORT_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>{Strings.INACTIVE_PORT_SUGGESTION_2}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.HW_FW_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.HW_FW_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>{Strings.HW_FW_SUGGESTION_2}</p>
          <p style={{ textAlign: "justify" }}>{Strings.HW_FW_SUGGESTION_3}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.MODULE_INCOHERENCE_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.MODULE_INCOHERENCE_SUGGESTION_1}</Header>
          <p>{Strings.MODULE_INCOHERENCE_SUGGESTION_2}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.DUPLEX_MISMATCH_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.DUPLEX_MISMATCH_SUGGESTION_1}</Header>
          <ul>
            <li>{Strings.DUPLEX_MISMATCH_SUGGESTION_2}</li>
            <li>{Strings.DUPLEX_MISMATCH_SUGGESTION_3}</li>
            <li>{Strings.DUPLEX_MISMATCH_SUGGESTION_4}</li>
          </ul>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.DELAY_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.DELAY_EXCEEDED_SUGGESTION_1}</Header>
          <p>{Strings.DELAY_EXCEEDED_SUGGESTION_2}</p>
          <p>{Strings.DELAY_EXCEEDED_SUGGESTION_3}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.INTERMITENT_FAILURE_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.INTERMITTENT_FAILURES_SUGGESTION_1}</Header>
          <ul>
            <li>{Strings.INTERMITTENT_FAILURES_SUGGESTION_2}</li>
            <li>{Strings.INTERMITTENT_FAILURES_SUGGESTION_3}</li>
            <li>{Strings.INTERMITTENT_FAILURES_SUGGESTION_4}</li>
          </ul>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.LOST_IP_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.LOST_IP_SUGGESTION_1}</Header>
          <p>{Strings.LOST_IP_SUGGESTION_2}</p>

        </Segment>
      );
    }
  }

  getProblemCards = () => {
    if (this.state.currentProblemList.length > 1) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.DETAILING}</Header>
          {
            this.state.currentProblemList.map(problem => (
              <ProblemCard
                key={problem._id}
                nowMillis={this.state.nowMillis}
                startTime={this.state.startTime}
                problem={problem} />
            ))
          }
          <Button
            fluid
            color='green'
            onClick={this.handleBatchCheckButtonClick}>
            {Strings.BATCH_CHECK}
          </Button>
        </Segment>
      );
    }
    else {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.DETAILING}</Header>
          {
            this.state.currentProblemList.map(problem => (
              <ProblemCard
                key={problem._id}
                nowMillis={this.state.nowMillis}
                startTime={this.state.startTime}
                problem={problem} />
            ))
          }
        </Segment>
      );
    }
  }

  handleCloseButtonClick = () => {
    this.setState({
      currentProblemType: "",
      currentProblemList: []
    }, () => {
      document.getElementById("no-task-selected-header").style.display = "block";
      document.getElementById("task-details").style.display = "none";
    });
  }

  handleBatchCheckButtonClick = () => {
    let data = JSON.stringify({
      type: this.state.currentProblemType,
      problems: this.state.currentProblemList
    });

    fetch(Constants.REQUEST_IP_ADDRESS + "solveAllProblems_POST", {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data
    })
      .then(UtilsInstance.checkStatus2)
      .then(() => {
        alert(Strings.ALL_EVENTS_WERE_CHECKED);

        // Mostre que não existem eventos
        document.getElementById("no-task-selected-header").style.display = "block";
        document.getElementById("task-details").style.display = "none";

        // Limpe as variáveis de eventos e pegue os dados atualizados
        this.setState({
          currentProblemType: "",
          currentProblemList: [],
        }, () => {
          this.retrieveData();
        });

      })
      .catch((error) => {
        let result = JSON.parse(error.message);

        let message = "";

        if (result.notSolved.length > 0) {

          message += this.getInitialErrorMessage(result.type) + "\n";

          for (let i = 0; i < result.notSolved.length; i++) {
            message += this.getErrorMessage(result.notSolved[i]);
          }

          message += Strings.CHECK_EVENT_OBS;
        }

        alert(message);

        // Feche a seção de solução
        document.getElementById("no-task-selected-header").style.display = "block";
        document.getElementById("task-details").style.display = "none";

        // Limpe as variáveis de eventos e pegue os dados atualizados
        this.setState({
          currentProblemType: "",
          currentProblemList: [],
        }, () => {
          this.retrieveData();
        });

      });
  }

  getInitialErrorMessage = (problemType) => {
    if (problemType === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_ALARMS_EVENTS;
    }
    else if (problemType === Constants.FAULT_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_FAULT_EVENTS;
    }
    else if (problemType === Constants.DUPLICATE_IP_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_DUPLICATE_IP_EVENTS;
    }
    else if (problemType === Constants.DUPLICATE_NAME_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_DUPLICATE_NAME_EVENTS;
    }
    else if (problemType === Constants.PING_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_PING_LIMIT_EVENTS;
    }
    else if (problemType === Constants.DELTA_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_DELTA_ERROR_EVENTS;
    }
    else if (problemType === Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_NOT_IN_FULL_DUPLEX_EVENTS;
    }
    else if (problemType === Constants.TRAFFIC_EXCESS_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_TRAFFIC_EXCESS_EVENTS;
    }
    else if (problemType === Constants.INACTIVE_PORT_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_INACTIVE_PORT_EVENTS;
    }
    else if (problemType === Constants.HW_FW_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_HW_FW_EVENTS;
    }
    else if (problemType === Constants.MODULE_INCOHERENCE_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_MODULE_INCOHERENCE_EVENTS;
    }
    else if (problemType === Constants.DUPLEX_MISMATCH_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_DUPLEX_MISMATCH_EVENTS;
    }
    else if (problemType === Constants.DELAY_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_DELAY_EXCEEDED_EVENTS;
    }
    else if (problemType === Constants.INTERMITENT_FAILURE_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_INTERMITTENT_FAILURE_EVENTS;
    }
    else if (problemType === Constants.LOST_IP_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_LOST_IP_EVENTS;
    }
    else {
      return "";
    }

  }

  getErrorMessage = (problem) => {
    if (problem.type === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return "• " + problem.ip + " / MAC: " + problem.mac + "\n";
    }
    else if (problem.type === Constants.FAULT_ERROR_TYPE) {
      return "• " + problem.ip + " / MAC: " + problem.mac + "\n";
    }
    else if (problem.type === Constants.DUPLICATE_IP_ERROR_TYPE) {
      let errorMsg = "• " + Strings.DUPLICATE_IP + problem.ip + "\n";
      for (let i = 0; i < problem.macs.length; i++) {
        errorMsg += "  • MAC: " + problem.macs[i] + "\n";
      }
      return errorMsg;
    }
    else if (problem.type === Constants.DUPLICATE_NAME_ERROR_TYPE) {
      let errorMsg = "• " + Strings.DUPLICATE_NAME_DP + problem.name + "\n";
      for (let i = 0; i < problem.macs.length; i++) {
        errorMsg += "  • IP: " + problem.ips[i] + " / MAC: " + problem.macs[i] + "\n";
      }
      return errorMsg;
    }
    else if (problem.type === Constants.PING_ERROR_TYPE) {
      return "• IP: " + problem.ip + " / " + Strings.MEDIUM_PING + ": " + problem.ping.toFixed(2) + " ms\n";
    }
    else if (problem.type === Constants.DELTA_ERROR_TYPE) {
      return "• " + problem.ip + " / MAC: " + problem.mac + "\n";
    }
    else if (problem.type === Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE) {
      return "• " + problem.ip + " / " + problem.portName + " / " + problem.MAUType + "\n";
    }
    else if (problem.type === Constants.TRAFFIC_EXCESS_ERROR_TYPE) {
      let errorMsg = "• IP: " + problem.ip + " / MAC: " + problem.mac + "\n";
      for (let i = 0; i < problem.ports.length; i++) { errorMsg += "  • " + Strings.PORT + ": " + problem.ports[i] + "\n"; }
      return errorMsg;
    }
    else if (problem.type === Constants.INACTIVE_PORT_ERROR_TYPE) {
      return problem.ip + " / " + problem.mac + " / " + problem.portName + "\n";
    }
    else if (problem.type === Constants.HW_FW_ERROR_TYPE) {
      let errorMsg = "• " + Strings.HARDWARE_VERSION + ": " + problem.hardwareVersion + "\n";
      for (let i = 0; i < problem.ips.length; i++) {
        errorMsg += " • " + problem.ips[i] + " / " + problem.macs[i] + " / Firmware: " + problem.firmwares[i] + "\n";
      }
      return errorMsg;
    }
    else if (problem.type === Constants.MODULE_INCOHERENCE_ERROR_TYPE) {
      let errorMsg = "• IP: " + problem.ip + " / MAC: " + problem.mac + "\n";
      errorMsg += "• " + Strings.MODULE + ": " + problem.module + "\n";
      errorMsg += " • " + Strings.RECEIVED_INFO + ":\n";
      errorMsg += "   • " + Strings.MODULE_NUMBER_DP + " " + problem.moduleNames[0] + "\n";
      errorMsg += "   • Order nº: " + problem.orderNumbers[0] + "\n";
      errorMsg += "   • Ident nº: " + problem.identNumbers[0] + "\n";
      errorMsg += " • " + Strings.EXPECTED_INFO + ":\n";
      errorMsg += "   • " + Strings.MODULE_NUMBER_DP + " " + problem.moduleNames[1] + "\n";
      errorMsg += "   • Order nº: " + problem.orderNumbers[1] + "\n";
      errorMsg += "   • Ident nº: " + problem.identNumbers[1] + "\n";
      return errorMsg;
    }
    else if (problem.type === Constants.DUPLEX_MISMATCH_ERROR_TYPE) {
      let errorMsg = Strings.DEVICE + " 1:\n";
      errorMsg += " • IP: " + problem.ips[0] + "\n";
      errorMsg += " • MAC: " + problem.macs[0] + "\n";
      errorMsg += " • " + Strings.PORT + ": " + problem.portNames[0] + "\n";
      errorMsg += " • " + Strings.DUPLEX_MODE + ": " + problem.MAUTypes[0] + "\n";
      errorMsg += Strings.DEVICE + " 2:\n";
      errorMsg += " • IP: " + problem.ips[1] + "\n";
      errorMsg += " • MAC: " + problem.macs[1] + "\n";
      errorMsg += " • " + Strings.PORT + ": " + problem.portNames[1] + "\n";
      errorMsg += " • " + Strings.DUPLEX_MODE + ": " + problem.MAUTypes[1] + "\n";
      return errorMsg;
    }
    else if (problem.type === Constants.DELAY_ERROR_TYPE) {
      return problem.ip + " / " + problem.mac + " / " + problem.portName + "\n";
    }
    else if (problem.type === Constants.INTERMITENT_FAILURE_ERROR_TYPE) {
      return "• " + problem.ip + " / MAC: " + problem.mac + "\n";
    }
    else if (problem.type === Constants.LOST_IP_ERROR_TYPE) {
      return "• 0.0.0.0 / MAC: " + problem.mac + "\n";
    }
    else {
      return "";
    }
  }

  // ------ TS Expert Report ------
  generateTsExpertReport = async () => {
    this.setGeneratingDimmerState(true);

    try {

      let promissesArray = [];

      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS + "tsExpert", { mode: "cors" })
          .then(res => res.json())
          .then(data => data)
      );

      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS + "traffic", { mode: "cors" })
          .then(res => res.json())
          .then(data => data)
      );

      promissesArray.push(
        // Get the start time
        fetch(Constants.REQUEST_IP_ADDRESS + "startTime", { mode: "cors" })
          .then(res => res.json())
          .then(data => data.startTime)
      );

      let resolvedPromisses = await Promise.all(promissesArray);

      let problems = resolvedPromisses[0];

      let traffic = resolvedPromisses[1].devices.sort((a, b) => {
        const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
        const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
        return num1 - num2;
      });

      let startTime = resolvedPromisses[2];

      let devicesWithErrosIncrements = this.getDevicesWithErrorsIncrement(traffic);
      let devicesWithExcessKbps = this.getDevicesWithExcessKbps(traffic);

      let reportGroupedProblems = {
        "diagnostic": [],
        "fault": [],
        "duplicatedIp": [],
        "duplicatedName": [],
        "avgPingExceededLimit": [],
        "deltaErr": [],
        "wrongMAUType": [],
        "excessKbps": [],
        "inactivePort": [],
        "firmwareIncoherence": [],
        "moduleIncoherence": [],
        "duplexMismatch": [],
        "lineDelayExceededLimit": [],
        "intermittentFailure": [],
        "lostIp": [],
      };

      for (let i = 0; i < problems.length; i++) {
        if (problems[i].type === Constants.DIAGNOSTIC_ERROR_TYPE) {
          reportGroupedProblems.diagnostic.push(problems[i]);
        }
        else if (problems[i].type === Constants.FAULT_ERROR_TYPE) {
          reportGroupedProblems.fault.push(problems[i]);
        }
        else if (problems[i].type === Constants.DUPLICATE_IP_ERROR_TYPE) {
          reportGroupedProblems.duplicatedIp.push(problems[i]);
        }
        else if (problems[i].type === Constants.DUPLICATE_NAME_ERROR_TYPE) {
          reportGroupedProblems.duplicatedName.push(problems[i]);
        }
        else if (problems[i].type === Constants.PING_ERROR_TYPE) {
          reportGroupedProblems.avgPingExceededLimit.push(problems[i]);
        }
        else if (problems[i].type === Constants.DELTA_ERROR_TYPE) {
          reportGroupedProblems.deltaErr.push(problems[i]);
        }
        else if (problems[i].type === Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE) {
          reportGroupedProblems.wrongMAUType.push(problems[i]);
        }
        else if (problems[i].type === Constants.TRAFFIC_EXCESS_ERROR_TYPE) {
          reportGroupedProblems.excessKbps.push(problems[i]);
        }
        else if (problems[i].type === Constants.INACTIVE_PORT_ERROR_TYPE) {
          reportGroupedProblems.inactivePort.push(problems[i]);
        }
        else if (problems[i].type === Constants.HW_FW_ERROR_TYPE) {
          reportGroupedProblems.firmwareIncoherence.push(problems[i]);
        }
        else if (problems[i].type === Constants.MODULE_INCOHERENCE_ERROR_TYPE) {
          reportGroupedProblems.moduleIncoherence.push(problems[i]);
        }
        else if (problems[i].type === Constants.DUPLEX_MISMATCH_ERROR_TYPE) {
          reportGroupedProblems.duplexMismatch.push(problems[i]);
        }
        else if (problems[i].type === Constants.DELAY_ERROR_TYPE) {
          reportGroupedProblems.lineDelayExceededLimit.push(problems[i]);
        }
        else if (problems[i].type === Constants.INTERMITENT_FAILURE_ERROR_TYPE) {
          reportGroupedProblems.intermittentFailure.push(problems[i]);
        }
        else if (problems[i].type === Constants.LOST_IP_ERROR_TYPE) {
          reportGroupedProblems.lostIp.push(problems[i]);
        }
      }

      const reportDocument = (
        <TsExpertReport
          nowMillis={Date.now()}
          startTime={startTime}
          diagnostic={reportGroupedProblems.diagnostic}
          fault={reportGroupedProblems.fault}
          duplicatedIp={reportGroupedProblems.duplicatedIp}
          duplicatedName={reportGroupedProblems.duplicatedName}
          avgPingExceededLimit={reportGroupedProblems.avgPingExceededLimit}
          deltaErr={devicesWithErrosIncrements}
          wrongMAUType={reportGroupedProblems.wrongMAUType}
          excessKbps={devicesWithExcessKbps}
          inactivePort={reportGroupedProblems.inactivePort}
          firmwareIncoherence={reportGroupedProblems.firmwareIncoherence}
          moduleIncoherence={reportGroupedProblems.moduleIncoherence}
          duplexMismatch={reportGroupedProblems.duplexMismatch}
          lineDelayExceededLimit={reportGroupedProblems.lineDelayExceededLimit}
          intermittentFailure={reportGroupedProblems.intermittentFailure}
          lostIp={reportGroupedProblems.lostIp}
        />
      );

      await this.downloadTsExpertReport(reportDocument);
      this.setGeneratingDimmerState(false);
    }
    catch (error) {
      console.error(error);
      this.setState({ isGenerateReportDimmerActive: false });
      alert(Strings.GENERATING_REPORT_ERROR);
    }
  }

  setGeneratingDimmerState = (isActive) => {
    if (!isActive) {
      this.setState({ isGenerateReportDimmerActive: isActive }, () => {
        alert(Strings.GENERATING_ACTIONS_LIST_SUCCESS);
      });
    }
    else {
      this.setState({ isGenerateReportDimmerActive: isActive });
    }
  }

  downloadTsExpertReport = async (reportDocument) => {
    const blob = await pdf(reportDocument).toBlob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    try {
      link.href = url;
      link.download = Strings.ACTIONS_LIST_NAME;
      document.body.appendChild(link);
      link.click();
    }
    finally {
      if (link.parentNode) {
        link.parentNode.removeChild(link);
      }
      URL.revokeObjectURL(url);
    }
  };

  getDevicesWithErrorsIncrement = (traffic) => {
    let devicesWithErrorIncrements = [];

    for (let i = 0; i < traffic.length; i++) {
      traffic[i].hasErrorsIncrement = false;

      for (let j = 0; j < traffic[i].ports.length; j++) {
        if (parseInt(traffic[i].ports[j].exitErrorsIncrement) > 0
          || parseInt(traffic[i].ports[j].inputErrorsIncrement) > 0) {
          traffic[i].ports[j].hasErrorsIncrement = true;
          traffic[i].hasErrorsIncrement = true;
        }
        else {
          traffic[i].ports[j].hasErrorsIncrement = false;
        }
      }

      if (traffic[i].hasErrorsIncrement) {
        devicesWithErrorIncrements.push(traffic[i]);
      }
    }

    return devicesWithErrorIncrements;
  }

  getDevicesWithExcessKbps = (traffic) => {
    let devicesWithExcessKbps = [];

    for (let i = 0; i < traffic.length; i++) {
      traffic[i].hasExcessKbps = false;

      for (let j = 0; j < traffic[i].ports.length; j++) {
        if (parseFloat(traffic[i].ports[j].exitKbps) > 50000
          || parseFloat(traffic[i].ports[j].inputKbps) > 50000) {
          traffic[i].ports[j].hasExcessKbps = true;
          traffic[i].hasExcessKbps = true;
        }
        else {
          traffic[i].ports[j].hasExcessKbps = false;
        }
      }

      if (traffic[i].hasExcessKbps) {
        devicesWithExcessKbps.push(traffic[i]);
      }
    }

    return devicesWithExcessKbps;
  }

  // ------ TS Expert Modal ------
  closeModal = () => {
    this.props.onProblemSolve(false, {});
    this.setState({ showModal: false });
  }

  handleCheckProblemClick = () => {
    // Se o usuário escolheu realmente conferir o evento, passamos ele para
    // a função de solucionar evento e passamos true para forçar a remoção
    this.solveProblem(this.props.solveProblem.problem, true);
  }

  retrieveData2 = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "tsExpert", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      // Get the start time
      fetch(Constants.REQUEST_IP_ADDRESS + "startTime", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.startTime)
    );

    let resolvedPromisses = await Promise.all(promissesArray);
    let problems = resolvedPromisses[0];
    let startTime = resolvedPromisses[1];

    if (problems.length > 0) {
      document.getElementById("problems-list").style.display = "block";
      document.getElementById("no-problem-detected-header").style.display = "none";

      let newGroupedProblems = {
        "diagnostic": [],
        "fault": [],
        "duplicatedIp": [],
        "duplicatedName": [],
        "avgPingExceededLimit": [],
        "deltaErr": [],
        "wrongMAUType": [],
        "excessKbps": [],
        "inactivePort": [],
        "firmwareIncoherence": [],
        "moduleIncoherence": [],
        "duplexMismatch": [],
        "lineDelayExceededLimit": [],
        "intermittentFailure": [],
        "lostIp": [],
      };

      for (let i = 0; i < problems.length; i++) {
        if (problems[i].type === Constants.DIAGNOSTIC_ERROR_TYPE) {
          newGroupedProblems.diagnostic.push(problems[i]);
        }
        else if (problems[i].type === Constants.FAULT_ERROR_TYPE) {
          newGroupedProblems.fault.push(problems[i]);
        }
        else if (problems[i].type === Constants.DUPLICATE_IP_ERROR_TYPE) {
          newGroupedProblems.duplicatedIp.push(problems[i]);
        }
        else if (problems[i].type === Constants.DUPLICATE_NAME_ERROR_TYPE) {
          newGroupedProblems.duplicatedName.push(problems[i]);
        }
        else if (problems[i].type === Constants.PING_ERROR_TYPE) {
          newGroupedProblems.avgPingExceededLimit.push(problems[i]);
        }
        else if (problems[i].type === Constants.DELTA_ERROR_TYPE) {
          newGroupedProblems.deltaErr.push(problems[i]);
        }
        else if (problems[i].type === Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE) {
          newGroupedProblems.wrongMAUType.push(problems[i]);
        }
        else if (problems[i].type === Constants.TRAFFIC_EXCESS_ERROR_TYPE) {
          newGroupedProblems.excessKbps.push(problems[i]);
        }
        else if (problems[i].type === Constants.INACTIVE_PORT_ERROR_TYPE) {
          newGroupedProblems.inactivePort.push(problems[i]);
        }
        else if (problems[i].type === Constants.HW_FW_ERROR_TYPE) {
          newGroupedProblems.firmwareIncoherence.push(problems[i]);
        }
        else if (problems[i].type === Constants.MODULE_INCOHERENCE_ERROR_TYPE) {
          newGroupedProblems.moduleIncoherence.push(problems[i]);
        }
        else if (problems[i].type === Constants.DUPLEX_MISMATCH_ERROR_TYPE) {
          newGroupedProblems.duplexMismatch.push(problems[i]);
        }
        else if (problems[i].type === Constants.DELAY_ERROR_TYPE) {
          newGroupedProblems.lineDelayExceededLimit.push(problems[i]);
        }
        else if (problems[i].type === Constants.INTERMITENT_FAILURE_ERROR_TYPE) {
          newGroupedProblems.intermittentFailure.push(problems[i]);
        }
        else if (problems[i].type === Constants.LOST_IP_ERROR_TYPE) {
          newGroupedProblems.lostIp.push(problems[i]);
        }
      }

      let currentProblemsList = this.getCurrentProblemsList(newGroupedProblems);

      if (currentProblemsList.length > 0) {
        this.setState({
          nowMillis: Date.now(),
          lastUpdate: new Date(),
          problems: problems,
          groupedProblems: newGroupedProblems,
          currentProblemType: this.state.currentProblemType,
          currentProblemList: currentProblemsList,
          startTime: startTime,
        });
      }
      else {
        this.setState({
          nowMillis: Date.now(),
          lastUpdate: new Date(),
          problems: problems,
          groupedProblems: newGroupedProblems,
          currentProblemType: "",
          currentProblemList: [],
          startTime: startTime,
        }, () => {
          document.getElementById("no-task-selected-header").style.display = "block";
          document.getElementById("task-details").style.display = "none";
        });
      }
    }
    else {
      this.setState({
        nowMillis: Date.now(),
        lastUpdate: new Date(),
        problems: [],
        groupedProblems: {
          "diagnostic": [],
          "fault": [],
          "duplicatedIp": [],
          "duplicatedName": [],
          "avgPingExceededLimit": [],
          "deltaErr": [],
          "wrongMAUType": [],
          "excessKbps": [],
          "inactivePort": [],
          "firmwareIncoherence": [],
          "moduleIncoherence": [],
          "duplexMismatch": [],
          "lineDelayExceededLimit": [],
          "intermittentFailure": [],
          "lostIp": [],
        },
        currentProblemType: "",
        currentProblemList: [],
        startTime: startTime,
      }, () => {
        document.getElementById("problems-list").style.display = "none";
        document.getElementById("no-problem-detected-header").style.display = "block";
        document.getElementById("no-task-selected-header").style.display = "block";
        document.getElementById("task-details").style.display = "none";
      });
    }
  }

  getCurrentProblemsList = (groupedProblems) => {
    if (this.state.currentProblemType === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return groupedProblems.diagnostic;
    }
    else if (this.state.currentProblemType === Constants.FAULT_ERROR_TYPE) {
      return groupedProblems.fault;
    }
    else if (this.state.currentProblemType === Constants.DUPLICATE_IP_ERROR_TYPE) {
      return groupedProblems.duplicatedIp;
    }
    else if (this.state.currentProblemType === Constants.DUPLICATE_NAME_ERROR_TYPE) {
      return groupedProblems.duplicatedName;
    }
    else if (this.state.currentProblemType === Constants.PING_ERROR_TYPE) {
      return groupedProblems.avgPingExceededLimit;
    }
    else if (this.state.currentProblemType === Constants.DELTA_ERROR_TYPE) {
      return groupedProblems.deltaErr;
    }
    else if (this.state.currentProblemType === Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE) {
      return groupedProblems.wrongMAUType;
    }
    else if (this.state.currentProblemType === Constants.TRAFFIC_EXCESS_ERROR_TYPE) {
      return groupedProblems.excessKbps;
    }
    else if (this.state.currentProblemType === Constants.INACTIVE_PORT_ERROR_TYPE) {
      return groupedProblems.inactivePort;
    }
    else if (this.state.currentProblemType === Constants.HW_FW_ERROR_TYPE) {
      return groupedProblems.firmwareIncoherence;
    }
    else if (this.state.currentProblemType === Constants.MODULE_INCOHERENCE_ERROR_TYPE) {
      return groupedProblems.moduleIncoherence;
    }
    else if (this.state.currentProblemType === Constants.DUPLEX_MISMATCH_ERROR_TYPE) {
      return groupedProblems.duplexMismatch;
    }
    else if (this.state.currentProblemType === Constants.DELAY_ERROR_TYPE) {
      return groupedProblems.lineDelayExceededLimit;
    }
    else if (this.state.currentProblemType === Constants.INTERMITENT_FAILURE_ERROR_TYPE) {
      return groupedProblems.intermittentFailure;
    }
    else if (this.state.currentProblemType === Constants.LOST_IP_ERROR_TYPE) {
      return groupedProblems.lostIp;
    }
    else {
      return [];
    }
  }

  checkProblem = async (problem) => {
    // Se o tipo de evento for a porta estar inativa,
    if (problem.type === Constants.INACTIVE_PORT_ERROR_TYPE) {
      let url = Constants.REQUEST_IP_ADDRESS + "devicePortStatus?mac=" + problem.mac + "&interface_label=" + problem.portName;
      let port = await fetch(url, { mode: "cors" })
        .then(res => res.json())
        .then(data => data);

      // Primeiro verificamos se a porta ainda está inativa, se ela estiver, 
      // perguntamos para o usuário se ele tem certeza que deseja marcar o evento como conferido
      if (port.status === "down") {
        this.setState({ showModal: true });
      }
      else {
        this.solveProblem(problem, false);
      }
    }
    else {
      this.solveProblem(problem, false);
    }
  }

  solveProblem = (problem, forceSolve) => {
    fetch(Constants.REQUEST_IP_ADDRESS + "solveProblem_POST", {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify({
        problem: problem,
        forceSolve: forceSolve
      })
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        this.setState({ showModal: false }, () => {
          alert(Strings.PROBLEM_CHECKED);
          this.props.onProblemSolve(false, {});
          document.getElementById(problem._id).style.display = "none";
          this.retrieveData2();
        });
      })
      .catch(() => {
        this.setState({ showModal: false }, () => {
          let message = this.singleProblemErrorMessage(problem.type) + "\n";
          alert(Strings.PROBLEM_CHECK_ERROR + "\n" + Strings.REASON_DP + message);
          this.props.onProblemSolve(false, {});
        });
      });
  }

  singleProblemErrorMessage = (problemType) => {
    if (problemType === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_ALARMS_EVENT;
    }
    else if (problemType === Constants.FAULT_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_FAULT_EVENT;
    }
    else if (problemType === Constants.DUPLICATE_IP_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_DUPLICATE_IP_EVENT;
    }
    else if (problemType === Constants.DUPLICATE_NAME_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_DUPLICATE_NAME_EVENT;
    }
    else if (problemType === Constants.PING_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_PING_LIMIT_EVENT;
    }
    else if (problemType === Constants.DELTA_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_DELTA_ERROR_EVENT;
    }
    else if (problemType === Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_NOT_IN_FULL_DUPLEX_EVENT;
    }
    else if (problemType === Constants.TRAFFIC_EXCESS_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_TRAFFIC_EXCESS_EVENT;
    }
    else if (problemType === Constants.INACTIVE_PORT_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_INACTIVE_PORT_EVENT;
    }
    else if (problemType === Constants.HW_FW_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_HW_FW_EVENT;
    }
    else if (problemType === Constants.MODULE_INCOHERENCE_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_MODULE_INCOHERENCE_EVENT;
    }
    else if (problemType === Constants.DUPLEX_MISMATCH_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_DUPLEX_MISMATCH_EVENT;
    }
    else if (problemType === Constants.DELAY_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_DELAY_EXCEEDED_EVENT;
    }
    else if (problemType === Constants.INTERMITENT_FAILURE_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_INTERMITTENT_FAILURE_EVENT;
    }
    else if (problemType === Constants.LOST_IP_ERROR_TYPE) {
      return Strings.UNABLE_TO_CHECK_LOST_IP_EVENT;
    }
    else {
      return "";
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    this.retrieveTagAndUptimeData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.retrieveTagAndUptimeData, 5000) });
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalID);
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState) {
    // Só tente resolver o problema quando o solve era falso e agora for true
    if (prevProps.solveProblem.solve !== this.props.solveProblem.solve
      && this.props.solveProblem.solve === true) {
      this.checkProblem(this.props.solveProblem.problem);
    }
  }

  render() {
    const totalProblemTypes = Object.keys(this.state.groupedProblems || {}).reduce((total, key) => {
      const group = this.state.groupedProblems[key];
      return total + (Array.isArray(group) && group.length > 0 ? 1 : 0);
    }, 0);

    return (
      <div className="ts-expert-page">
        <div className="ts-expert-hero">
          <div className="ts-expert-title-area">
            <div>
              <div className="ts-expert-title">{this.state.networkTag || "TS Expert"}</div>
              <div className="ts-expert-subtitle">{Strings.TS_EXPERT_SMART_DIAGNOSIS}</div>
            </div>
          </div>

          <div className="ts-expert-summary-cards">
            <div className="ts-expert-summary-card">
              <span className="ts-expert-summary-value">{totalProblemTypes}</span>
              <span className="ts-expert-summary-label">{Strings.TS_EXPERT_EVENT_TYPES}</span>
            </div>
            <div className="ts-expert-summary-card">
              <span className="ts-expert-summary-value">{this.state.problems.length}</span>
              <span className="ts-expert-summary-label">{Strings.TS_EXPERT_OCCURRENCES}</span>
            </div>
            <div className="ts-expert-summary-card ts-expert-summary-card-wide">
              <span className="ts-expert-summary-value ts-expert-uptime-value">
                <Icon color="green" name="arrow alternate circle up" />
                <span className="ts-expert-uptime-label">{Strings.UP_TIME}</span>
                <span>{this.state.uptime || "-"}</span>
              </span>
            </div>
          </div>

          <div className="ts-expert-actions-area">
            <Button
              className="ts-expert-export-button"
              content={Strings.EXPORT_ACTIONS_LIST}
              color="teal"
              onClick={this.generateTsExpertReport} />
            <Dimmer page active={this.state.isGenerateReportDimmerActive}>
              <Loader size="big">{Strings.GENERATING_ACTIONS_LIST_WAITING}</Loader>
            </Dimmer>

          </div>
        </div>

        <Grid className="ts-expert-main-grid" style={gridStyle} columns={2} doubling>
          <Grid.Column>
            <Segment className="ts-expert-panel ts-expert-events-panel" style={leftSegmentStyle}>
              <div className="ts-expert-panel-title"><Icon name="list alternate outline" /><span>{Strings.EVENTS_LIST}</span></div>
              <Divider clearing />
              <Segment id="problems-list" className="ts-expert-list-segment" style={listSegmentStyle} basic>
                <List size="medium" animated divided style={listStyle}>
                  {this.getListItem(Constants.DIAGNOSTIC_ERROR_TYPE, this.state.groupedProblems.diagnostic)}
                  {this.getListItem(Constants.FAULT_ERROR_TYPE, this.state.groupedProblems.fault)}
                  {this.getListItem(Constants.DUPLICATE_IP_ERROR_TYPE, this.state.groupedProblems.duplicatedIp)}
                  {this.getListItem(Constants.DUPLICATE_NAME_ERROR_TYPE, this.state.groupedProblems.duplicatedName)}
                  {this.getListItem(Constants.PING_ERROR_TYPE, this.state.groupedProblems.avgPingExceededLimit)}
                  {this.getListItem(Constants.DELTA_ERROR_TYPE, this.state.groupedProblems.deltaErr)}
                  {this.getListItem(Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE, this.state.groupedProblems.wrongMAUType)}
                  {this.getListItem(Constants.TRAFFIC_EXCESS_ERROR_TYPE, this.state.groupedProblems.excessKbps)}
                  {this.getListItem(Constants.INACTIVE_PORT_ERROR_TYPE, this.state.groupedProblems.inactivePort)}
                  {this.getListItem(Constants.HW_FW_ERROR_TYPE, this.state.groupedProblems.firmwareIncoherence)}
                  {this.getListItem(Constants.MODULE_INCOHERENCE_ERROR_TYPE, this.state.groupedProblems.moduleIncoherence)}
                  {this.getListItem(Constants.DUPLEX_MISMATCH_ERROR_TYPE, this.state.groupedProblems.duplexMismatch)}
                  {this.getListItem(Constants.DELAY_ERROR_TYPE, this.state.groupedProblems.lineDelayExceededLimit)}
                  {this.getListItem(Constants.INTERMITENT_FAILURE_ERROR_TYPE, this.state.groupedProblems.intermittentFailure)}
                  {this.getListItem(Constants.LOST_IP_ERROR_TYPE, this.state.groupedProblems.lostIp)}
                </List>
              </Segment>
              <Header textAlign="center" style={noTaskHeaderSelectedStyle} id="no-problem-detected-header" as="h2" icon color="teal">
                <Icon name="check circle" color="teal" />
                {Strings.NO_PROBLEM_DETECTED}
                <Header.Subheader><p>{Strings.NO_EVENTS_TO_BE_ANALYZED}</p></Header.Subheader>
              </Header>
            </Segment>
          </Grid.Column>

          <Grid.Column>
            <Segment className="ts-expert-panel ts-expert-actions-panel" style={rightSegmentStyle}>
              <div className="ts-expert-panel-title"><Icon name="tasks" /><span>{Strings.ACTIONS}</span></div>
              <Divider clearing />
              <Header textAlign="center" style={noTaskHeaderSelectedStyle} id="no-task-selected-header" as="h2" icon color="teal">
                <Icon name="edit outline" color="teal" />
                {Strings.NO_EVENT_SELECTED}
                <Header.Subheader>{Strings.CHOOSE_AN_EVENT}</Header.Subheader>
              </Header>
              <Segment id="task-details" className="ts-expert-task-details" style={taskSegmentStyle}>
                <Button size="tiny" circular icon="times" onClick={this.handleCloseButtonClick} />
                {this.getActions()}
                {this.getProblemCards()}
              </Segment>
            </Segment>
          </Grid.Column>
        </Grid>

        <Modal style={modalStyle} centered open={this.state.showModal} onClose={this.closeModal} size="small">
          <Header icon="trash" content={Strings.PORT_IS_STILL_INACTIVE} />
          <Modal.Content><p>{Strings.MARK_PROBLEM_AS_SOLVED}</p></Modal.Content>
          <Modal.Actions>
            <Button color="red" onClick={this.closeModal}><Icon name="times" />{Strings.NO}</Button>
            <Button color="green" onClick={this.handleCheckProblemClick}><Icon name="checkmark" />{Strings.YES}</Button>
          </Modal.Actions>
        </Modal>

        <div className="ts-expert-last-update" style={lastUpdateContainerStyle}>
          <div><p><b>{Strings.LAST_UPDATED}</b>{this.state.lastUpdate.toLocaleString("pt-BR")}{Strings.THIS_COMPUTER_TIME}</p></div>
          <div><Button style={{ marginLeft: "8px" }} circular color="teal" icon="refresh" onClick={this.retrieveData2} /></div>
        </div>
      </div>
    );
  }

}

const mapStateToProps = state => ({
  solveProblem: state.solveProblem,
});

const mapActionsToProps = {
  onProblemSolve: solveProblemAction
};

const gridStyle = {
  marginLeft: "2vw",
  marginRight: "2vw"
};

const listStyle = {
  marginLeft: "24px",
  marginRight: "24px"
};

const leftSegmentStyle = {
  height: "calc(100vh - 270px)",
  minHeight: "460px"
};

const rightSegmentStyle = {
  height: "calc(100vh - 270px)",
  minHeight: "460px"
};

const listSegmentStyle = {
  display: "none",
  overflowY: "auto",
  height: "calc(100vh - 380px)",
  minHeight: "350px"
};

const taskSegmentStyle = {
  display: "none",
  overflowY: "auto",
  height: "calc(100vh - 380px)",
  minHeight: "350px"
};

const noTaskHeaderSelectedStyle = {
  marginTop: "10vh"
};

const listContentStyle = {
  marginTop: "4px",
  marginBottom: "4px"
};


const modalStyle = {
  width: "800px",
  height: "185px",
  margin: "20vh auto"
};

const headerStyle = {
  marginTop: "8px",
  marginBottom: "8px",
};

const lastUpdateContainerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "8px"
};

export default connect(mapStateToProps, mapActionsToProps)(withRouter(TSExpert));
